import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import { ItemTypes } from './ItemTypes';
import RoomItem from './RoomItem';
import { Segment } from 'semantic-ui-react';

const roomSource = {
  beginDrag({ toggleRoom, room, transfer }) {
    if (transfer.length === 0 && typeof room === 'object') {
      toggleRoom(room);
    }
    return {
      room
    };
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}
const RoomDragContext = ({
  connectDragSource,
  isDragging,
  room,
  toggleRoom,
  active
}) => {
  return connectDragSource(
    <div
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: 'move'
      }}>
      <RoomItem room={room} handleClick={toggleRoom} active={active} />
    </div>
  );
};
export default DragSource(ItemTypes.ROOM, roomSource, collect)(RoomDragContext);



// WEBPACK FOOTER //
// ./src/cleaning/schedule/roomPicker/components/RoomDragContext.js